import React, { forwardRef } from "react";

interface CustomInputProps {
  value?: string;
  onClick?: () => void;
  onChange?: any;
  placeholder?: string;
  className?: string;
}

const CustomInput = forwardRef<HTMLInputElement, CustomInputProps>(
  ({ value, onClick, onChange, placeholder, className }, ref) => {
    return (
      <input
        ref={ref}
        value={value}
        onClick={onClick}
        onChange={(e) => {
          onChange(e);
        }}
        placeholder={placeholder}
        className={className}
      />
    );
  }
);
export default CustomInput;